import React, { useEffect, useState } from "react";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import IndicatorIdentity from "components/modal/dataModal/data/modaljustify/identity/components/body/import/indicator";
import Pi from "components/modal/dataModal/data/modaljustify/identity/components/body/import/pi";
import Selfie from "components/modal/dataModal/data/modaljustify/identity/components/body/selfie";
import Autorisationtravail from "components/modal/dataModal/data/modaljustify/identity/components/body/autorisationtravail";
import Confirmation from "components/modal/dataModal/data/modaljustify/identity/components/body/import/confirmation";
import Footerbutton from "components/modal/dataModal/data/modaljustify/identity/components/body/import/footerbutton";
import usefetchdata from "hooks/usefetchdata";
import axios from "axios";
import { toast } from "react-toastify";
import UseContext from "hooks/useContext";
import LoadingButton from "components/button/loading.js";
import { convertPdfToImageIfNeeded } from "utils/pdfToImage";

const Modalidentity = () => {
    const { tempWorkerData } = usefetchdata();
    const { refreshLoadWorker, language } = UseContext();
    const [formIndex, setFormIndex] = useState(1);
    const [nationality, setNationality] = useState("");
    const [check, setCheck] = useState(false);
    const [loading, setLoading] = useState(false);
    const { toggle } = useModal();
    // piece d'identité

    const [pi, setPi] = useState({
        type: "",
        fileR: null,
        fileV: null,
        nationality: "",
    });
    const [selfie, setSelfie] = useState(null);
    const [visa, setVisa] = useState({
        type: "",
        fileR: null,
        fileV: null,
        nationality: "",
    });
    const elements = [
        <Pi
            key={Pi}
            pi={pi}
            setPi={setPi}
            check={check}
            setCheck={setCheck}
            formIndex={formIndex}
        />,
        <Selfie key={Selfie} setSelfie={setSelfie} />,
        <Confirmation
            key={Confirmation}
            userData={tempWorkerData}
            setFormIndex={setFormIndex}
            nationality={nationality}
        />,
        <Confirmation
            key={Confirmation}
            userData={tempWorkerData}
            setFormIndex={setFormIndex}
            nationality={nationality}
        />,
        <Pi
            key={Pi}
            pi={pi}
            setPi={setPi}
            check={check}
            nationality={nationality}
            setCheck={setCheck}
            formIndex={formIndex}
        />,
        <Selfie key={Selfie} setSelfie={setSelfie} />,
    ];
    const elements2 = [
        <Pi
            key={Pi}
            pi={pi}
            setPi={setPi}
            check={check}
            setCheck={setCheck}
            formIndex={formIndex}
        />,
        <Selfie key={Selfie} setSelfie={setSelfie} />,
        <Autorisationtravail
            key={Autorisationtravail}
            setVisa={setVisa}
            visa={visa}
        />,
        <Confirmation
            key={Confirmation}
            userData={tempWorkerData}
            setFormIndex={setFormIndex}
            nationality={nationality}
        />,
        <Confirmation
            key={Confirmation}
            userData={tempWorkerData}
            setFormIndex={setFormIndex}
            nationality={nationality}
        />,
        <Pi
            key={Pi}
            pi={pi}
            setPi={setPi}
            check={check}
            nationality={nationality}
            setCheck={setCheck}
            formIndex={formIndex}
        />,
        <Selfie key={Selfie} setSelfie={setSelfie} />,
        <Autorisationtravail
            key={Autorisationtravail}
            setVisa={setVisa}
            visa={visa}
        />,
    ];
    const effect1 = (f) =>
        f.identity?.validated === "1" && f.visa?.validated === "1";
    const effect2 = (f) => f.identity?.validated === "1";
    useEffect(() => {
        if (pi.nationality !== "" && pi.nationality !== nationality) {
            setNationality(pi.nationality);
        } else {
            if (effect2(tempWorkerData) || effect1(tempWorkerData)) {
                if (effect1(tempWorkerData)) {
                    setNationality("NUE");
                    setFormIndex(5);
                } else {
                    setNationality("UE");
                    setFormIndex(4);
                }
            } else {
                setFormIndex(1);
            }
        }
    }, [tempWorkerData, pi.nationality]);

    // Log current page
    useEffect(() => {
        console.log(`📄 [Modal Identity] Page actuelle: ${formIndex}`);
    }, [formIndex]);

    const state1 = (f) =>
        f.type !== "" && f.nationality !== "" && f.fileR !== "";
    const state2 = (f) => f !== null && f !== "";
    const state3 = (f) =>
        f.type !== "" &&
        f.fileR !== "" &&
        ((f.type === "Visa" && f.fileV !== "") || f.type === "RTS");

    const handleIndex = (e) => {
        if (check) {
            if (formIndex < 1) setFormIndex(1);

            if (
                (formIndex === 1 && state1(pi) && state2(selfie)) ||
                (formIndex === 2 && state2(selfie) && state1(pi)) ||
                (formIndex === 3 && state3(visa))
            )
                setFormIndex(formIndex + 1);
            else {
                if (formIndex === 1 || formIndex === 2) {
                    toast.warning("Veuillez remplir tous les champs (identité et selfie)");
                } else {
                    toast.warning("Veuillez remplir les champs");
                }
            }
        } else {
            toast.warning("Veuillez cocher l'attestation sur l'honneur");
        }
    };

    const f = async (formData, successMsg) => {
        setLoading(true);
        const idToastLoad = toast.loading("Envoi des fichiers en cours");
        try {
            const result = await axios.post(
                `${process.env.REACT_APP_API_URL}upload/files`,
                formData
            );
            if (result.status === 201) {
                setLoading(false);
                toast.update(idToastLoad, {
                    render: "Fichiers uploadés",
                    type: "success",
                    autoClose: 3000,
                    isLoading: false,
                });
                refreshLoadWorker();
                toggle();
            } else {
                setLoading(false);
                toast.update(idToastLoad, {
                    render: "Erreur d'envoi des fichiers",
                    type: "error",
                    isLoading: false,
                });
            }
        } catch (error) {
            setLoading(false);
            toast.update(idToastLoad, {
                render: "Erreur d'envoi des fichiers",
                type: "error",
                isLoading: false,
            });
        }
    };

    const m = async (formData, successMsg) => {
        try {
            const result = await axios.post(
                `${process.env.REACT_APP_API_URL}upload/files`,
                formData
            );

            if (result.status === 201) {
                toast.success(successMsg);
                if (nationality === "NUE") {
                    setFormIndex(5);
                    refreshLoadWorker();
                } else {
                    refreshLoadWorker();
                    setFormIndex(4);
                }
                toggle();
            } else {
                toast.error("Un problème est survenu");
            }
        } catch (error) {
            // Gérer les erreurs lors de l'envoi des fichiers
            console.error("Erreur lors de l'envoi des fichiers :", error.message);
            toast.error("Un problème est survenu lors de l'envoi des fichiers");
        }
    };

    //UE - PASSEPORT -SELFIE
    const uePassSelfie = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };

    //UE - CNI RECTO - CNI VERSO -SELFIE
    const ueCniSelfie = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };

    //NUE PASSEPORT - SELFIE - RTS
    const etrPasseportSelfieRts = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };
    //NUE PASSEPORT - SELFIE - VISA R - VISA V
    const etrPasseportSelfieVisaRV = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };
    //NUE CNI R - CNI V - SELFIE - RTS
    const etrCniSelfieVisaR = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };
    //NUE CNI R - CNI V - SELFIE - VISA R - VISA V
    const etrCniSelfieVisaRV = async (formData) => {
        await f(formData, 'Le document "Identité" est' + " ajouté.");
    };

    const modifyPIR = async (formData) => {
        await m(formData, 'Le document "Identité" est' + " ajouté.");
    };

    const modifyPIRV = async (formData) => {
        await m(formData, 'Le document "Identité" est' + " modifié.");
    };

    const modifySelfie = async (formData) => {
        await m(formData, 'Le document "selfie" est' + " modifié.");
    };

    const modifyVisaR = async (formData) => {
        await m(formData, 'Le document "Identité" est' + " modifié.");
    };

    const modifyVisaRV = async (formData) => {
        await m(formData, 'Le document "Identité" est modifié.');
    };
    const handleSubmitMulti = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("xsrfToken");
        const formData = new FormData();
        formData.append("token", token);

        if (check && pi.fileR !== "" && selfie !== null) {
            // Convert PDFs to images if needed
            const identityRFile = await convertPdfToImageIfNeeded(pi.fileR);
            const selfieFile = await convertPdfToImageIfNeeded(selfie);
            
            formData.append("identityR", identityRFile);
            formData.append("identityType", pi.type);
            formData.append("selfie", selfieFile);

            if (pi.type === "Passeport" && pi.nationality === "UE") {
                await uePassSelfie(formData);
            } else if (pi.type === "CNI" && pi.nationality === "UE") {
                const identityVFile = await convertPdfToImageIfNeeded(pi.fileV);
                formData.append("identityV", identityVFile);
                await ueCniSelfie(formData);
            } else if (pi.type === "Passeport" && pi.nationality === "NUE") {
                const visaRFile = await convertPdfToImageIfNeeded(visa.fileR);
                formData.append("visaR", visaRFile);
                formData.append("visaType", visa.type);
                if (visa.type === "RTS") {
                    await etrPasseportSelfieRts(formData);
                } else {
                    const visaVFile = await convertPdfToImageIfNeeded(visa.fileV);
                    formData.append("visaV", visaVFile);
                    await etrPasseportSelfieVisaRV(formData);
                }
            } else if (pi.type === "CNI" && pi.nationality === "NUE") {
                const identityVFile = await convertPdfToImageIfNeeded(pi.fileV);
                const visaRFile = await convertPdfToImageIfNeeded(visa.fileR);
                formData.append("identityV", identityVFile);
                formData.append("visaR", visaRFile);
                formData.append("visaType", visa.type);
                if (visa.type === "RTS") {
                    await etrCniSelfieVisaR(formData);
                } else {
                    const visaVFile = await convertPdfToImageIfNeeded(visa.fileV);
                    formData.append("visaV", visaVFile);
                    await etrCniSelfieVisaRV(formData);
                }
            }
        } else {
            toast.warning("Veuillez remplir tous les champs (identité et selfie)");
        }
    };
    
    const handleModifyIdentityAndSelfie = async (e) => {
        e.preventDefault();
        if (!check) {
            toast.warning("Veuillez cocher l'attestation sur l'honneur");
            return;
        }
        
        if (pi.fileR === null || selfie === null) {
            toast.warning("Veuillez importer à la fois l'identité et le selfie");
            return;
        }
        
        if (pi.type === "CNI" && pi.fileV === null) {
            toast.warning("Veuillez importer le verso de la CNI");
            return;
        }
        
        const token = localStorage.getItem("xsrfToken");
        const formData = new FormData();
        formData.append("token", token);
        
        // Convert PDFs to images if needed
        const identityRFile = await convertPdfToImageIfNeeded(pi.fileR);
        const selfieFile = await convertPdfToImageIfNeeded(selfie);
        
        formData.append("identityR", identityRFile);
        formData.append("identityType", pi.type);
        formData.append("selfie", selfieFile);

        if (pi.type === "Passeport") {
            await modifyPIR(formData);
        } else if (pi.type === "CNI") {
            const identityVFile = await convertPdfToImageIfNeeded(pi.fileV);
            formData.append("identityV", identityVFile);
            await modifyPIRV(formData);
        }
    };
    const handleModifyVisa = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("xsrfToken");
        const formData = new FormData();
        formData.append("token", token);
        formData.append("visaR", visa.fileR);
        formData.append("visaType", visa.type);
        if (visa.type === "RTS") {
            await modifyVisaR(formData);
        } else {
            formData.append("visaV", visa.fileV);
            await modifyVisaRV(formData);
        }
    };

    const handleClose = (e) => {
        toggle();
    };
    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                {language.getValue("justify.m_identity_title_c")}
            </Modalheader>
            <ModalBody>
                <IndicatorIdentity
                    pi={pi}
                    nationality={nationality}
                    formIndex={formIndex}
                />

                {(pi.nationality === "NUE" || nationality === "NUE"
                    ? elements2
                    : elements
                ).filter((item, index) => index + 1 === formIndex)}
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <LoadingButton size={"LG"} />
                ) : (
                    <>
                        <Button
                            size={"LG"}
                            color={"SECONDARY"}
                            onClick={toggle}
                        >
                            Annuler
                        </Button>
                        <Footerbutton
                            formIndex={formIndex}
                            pi={pi.nationality}
                            nationality={nationality}
                            oC1={handleIndex}
                            oC2={handleSubmitMulti}
                            oC3={handleClose}
                            oC4={handleModifyIdentityAndSelfie}
                            oC5={handleModifyIdentityAndSelfie}
                            oC6={handleModifyVisa}
                        />
                    </>
                )}
            </ModalFooter>
        </>
    );
};

export default Modalidentity;
